import { observer } from "mobx-react";
import * as React from "react";
import { type HelpTag } from "../../help-types";
import { store } from "../../store";
import css from "./help-tag-bubble.scss";

export interface HelpTagBubbleProps {
    readonly tag: HelpTag;
}

@observer
export class HelpTagBubble extends React.Component<HelpTagBubbleProps> {
    public render(): JSX.Element {
        const { tag } = this.props;
        return (
            <div className={css.helpTagBubble} onClick={() => store.serviceHelp.browseTag(tag)}>
                <span className={css.helpTagBubble__name}>{store.i18n.t(tag.title)}</span>
                <span className={css.helpTagBubble__count}>
                    {store.serviceHelp.countArticlesInTag(tag)}
                </span>
            </div>
        );
    }
}
